import { render, staticRenderFns } from "./statistical-analysis-skeleton-chart.vue?vue&type=template&id=67e41f50&scoped=true&"
import script from "./statistical-analysis-skeleton-chart.ts?vue&type=script&lang=ts&"
export * from "./statistical-analysis-skeleton-chart.ts?vue&type=script&lang=ts&"
import style0 from "./statistical-analysis-skeleton-chart.scss?vue&type=style&index=0&id=67e41f50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e41f50",
  null
  
)

export default component.exports